import { PlusOutlined } from '@ant-design/icons';
import AppButton from '@nxsys/components/AppButton';
import AppInputSearch from '@nxsys/components/AppInputSearch';
import AppMenuFilter from '@nxsys/components/AppMenuFilter';
import { defaultDocumentsStatus } from '@nxsys/constants/AppConstants';
import { AppState } from '@nxsys/store';
import type { GetDocumentParams } from '@nxsys/types/models/document';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import AgencyDocumentsFilterModal from './AgencyDocumentsFilterModal';
import EmployeeReportByFilterModal, {
  EmployeeReportByFilters,
} from './EmployeeReportByFilterModal';
import { StyledFlex } from './index.styled';

type OptionType = {
  label: string;
  value: string;
  [key: string]: any;
};
type DocumentContentHeaderPropsTypes = {
  isFilterStatus?: boolean;
  isCreate?: boolean;
  isEmployee?: boolean;
  reportBy?: EmployeeReportByFilters;
  onToggleCreate?: () => void;
  onChangeStatus?: (value: string) => void;
  onChangeReportBy?: (value: EmployeeReportByFilters) => void;
  onChangeSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFilterAgency?: (params: GetDocumentParams) => void;
};

const DocumentContentHeader = (props: DocumentContentHeaderPropsTypes) => {
  const {
    isCreate = false,
    isFilterStatus = false,
    isEmployee = false,
    reportBy = { reportBy: [] },
    onToggleCreate = () => {},
    onChangeSearch = () => {},
    onChangeStatus = () => {},
    onChangeReportBy = () => {},
    onFilterAgency,
  } = props;
  const { isAgency } = useSelector((state: AppState) => state.appStore);

  const [searchTerm, setSearchTerm] = useState<string>('');
  const [openFilter, setOpenFilter] = useState(false);

  const toggleFilter = () => setOpenFilter((prev) => !prev);

  const onChangeSearchTerm = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);
    onChangeSearch(e);
  };

  const onChangeSelect = (option: OptionType) => {
    onChangeStatus && onChangeStatus(option?.value);
  };

  const handleFilterAgency = (params: GetDocumentParams) => {
    onFilterAgency?.(params);
  };

  const renderFilter = () => {
    if (isEmployee) {
      return (
        <>
          <AppMenuFilter
            options={[]}
            onChange={() => {}}
            onClick={toggleFilter}
          />
          <EmployeeReportByFilterModal
            isOpen={openFilter}
            toggle={toggleFilter}
            title="Filter"
            value={reportBy}
            onApply={onChangeReportBy}
          />
        </>
      );
    }

    if (isAgency) {
      return (
        <>
          <AppMenuFilter
            options={[]}
            onChange={() => {}}
            onClick={toggleFilter}
          />
          <AgencyDocumentsFilterModal
            isOpen={openFilter}
            toggle={toggleFilter}
            title="Filter"
            onFilter={handleFilterAgency}
          />
        </>
      );
    }

    return (
      <AppMenuFilter
        options={[{ label: 'All', value: '' }, ...defaultDocumentsStatus]}
        onChange={onChangeSelect}
      />
    );
  };

  return (
    <>
      <StyledFlex style={{ overflow: 'auto' }}>
        <div className="flex justify-between w-full">
          <div className="flex">
            <div style={{ marginRight: 12 }}>
              <AppInputSearch
                value={searchTerm}
                onChange={onChangeSearchTerm}
              />
            </div>
            {isFilterStatus && renderFilter()}
          </div>
          {isCreate && (
            <AppButton
              type="primary"
              name="Add New"
              icon={<PlusOutlined />}
              onClick={onToggleCreate}
            />
          )}
        </div>
      </StyledFlex>
    </>
  );
};

export default DocumentContentHeader;
